"use strict"
const apiURL = require('../../apiURL');
const request = require('ks_request');
const { array_api_inputs, output_object } = require('ks_data_protocol');

const create_sdk = (data_definition, enableRequestPerformanceLog = false) => {
    let new_sdk = {};
    for (let def in data_definition.procedures) {
        new_sdk[def] = (token, inputs, with_relations = true, files = [], delay = null, dataProvider = null, showRequest= false) => {
            return new Promise(async(resolve, reject) => {
                try {
                    try { if (typeof app !== undefined && app !== null) { app['inactiveTime'] = 0; } } catch (err) {}
                    let reqData;
                    let response = data_definition.procedures[def].mock_data;
                    let url = `${apiURL}/${data_definition.config.api}/${data_definition.procedures[def].definition.name}`;
                    let dataInputs = Array.isArray(inputs)? inputs: array_api_inputs(data_definition.procedures[def].definition.inputs, inputs);
                    if (files.length > 0) {
                        let formData = new FormData();
                        for (let file of files) {
                            formData.append('--uploadedFiles--', file);
                        }
                        formData.append('inputs', dataInputs);
                        if(dataProvider) formData.append('x-data-provider', dataProvider);
                        reqData = formData;
                        url = `${url}?token=${token}`;
                    } else {
                        reqData = { inputs: dataInputs, token: token, delay: delay };
                        if(dataProvider) reqData['x-data-provider'] = dataProvider;
                    }
                    var req = {
                        url: url,
                        method: 'POST',
                        data: reqData
                    };
                    if (apiURL) {
                        let res = await request(req, false, enableRequestPerformanceLog);
                        let apiVersion = res.headers[`${data_definition.config.module_name}-api-version`]?res.headers[`${data_definition.config.module_name}-api-version`]:null;
                        if( (apiVersion != null && data_definition.version != null) && apiVersion != data_definition.version){
                            console.log(`The definition file for the UI Version for ${data_definition.config.module_name}(${data_definition.version}) is not the same with the API(${apiVersion}).\n `);
                        }
                        response = res.data;
                    }
                    if (Array.isArray(response)) {
                        let data = output_object(response, data_definition.procedures[def].definition.outputs, with_relations);
                        if (data.result_set[0].error_number === 0) {
                            if(showRequest) resolve({"response": data, "request": req })
                            else resolve(data);
                        } else {
                            if(showRequest) reject({"response": data.result_set, "request": req });
                            else reject(data.result_set);
                        }
                    } else {
                        if(showRequest) resolve({"response": response, "request": req })
                        else resolve(response);
                    }
                } catch (err) {
                    //reject([{ error_number: 500, error_text: `Invalid Inputs : ${err && typeof err === 'object'?JSON.stringify(err):err}`, error: err }]);
                    if(showRequest) reject({"response":[{ error_number: 500, error_text: err }], "request": req});
                    else reject([{ error_number: 500, error_text: err }]);
                }
            });
        };
        new_sdk[`${def}_inputs`] = data_definition.procedures[def].definition.inputs;
        new_sdk[`${def}_outputs`] = data_definition.procedures[def].definition.outputs;
    }
    return new_sdk;
}

module.exports = create_sdk;